import styles from "../../styles/shared/exchanges/ExchangeRecommendationModal.module.css";
import { Modal } from "antd";
import icon from "../../asset/Icons/question.gif";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  openExchangeConnectionSettings,
  setSelectedPortfolioExchange,
} from "../../redux/exchange/actions";
import useUserData from "../../hooks/useUserData";

function ExchangeRecommendationModal({ show, setShow, exchange }) {
  const { username, email } = useUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToSettings = () => {
    // navigate(`/integrate-exchange/${exchange.name}`);
    // dispatch(setPreviousPath(location.pathname));
    // dispatch(setExchangeForConnection(exchange.id));
    dispatch(openExchangeConnectionSettings(exchange.id));
  };

  const goToPortfolio = () => {
    dispatch(setSelectedPortfolioExchange(exchange.id, username, email));
    navigate("/portfolio");
  };

  return (
    <Modal
      open={show}
      onCancel={() => setShow(false)}
      centered
      footer={null}
      maskClosable={false}
      width={450}
    >
      <div className={styles.container}>
        <img src={icon} alt={"question"} />
        <h3 className={styles.title}>
          What would you like to do next?
          <br />
          See your portfolio or tweak the settings?
        </h3>
        <div className={styles.btns}>
          <span className={styles.portfolioBtn} onClick={goToPortfolio}>
            See your portfolio
          </span>
          <span className={styles.settingBtn} onClick={goToSettings}>
            Tweak the settings
          </span>
        </div>
      </div>
    </Modal>
  );
}

export default ExchangeRecommendationModal;
